import { BreadCrumbOption } from '@service-victoria/component-library/ts/props';
import Crypto from 'crypto';

import t from 'content';

/**
 * Maximum time allowed for keeping the user ssession active wihtout any action
 */
export const SESSION_TIMEOUT_THRESHOLD_MILLISECONDS = 300000;

/**
 * nonce unqiue code for CSP protection
 */
export const nonce = 'nonce-' + Crypto.randomBytes(16).toString('base64');

export const STATUS_CODES = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500
};
export const breadCrumbs: BreadCrumbOption[] = [
  {
    text: 'Business',
    link: 'https://service.vic.gov.au/business'
  },
  {
    text: t('page-title'),
    link: ''
  }
];
export const GenericValidationErrors = {
  required: 'We can’t help you without this information.',
  nameChars:
    'Sorry, names must start and end with A-Z. Punctuation in the middle is fine. e.g. O’Connor, al-Tammar.',
  genericError: 'We can’t help you without this information.',
  mandatoryCheckbox: `Please confirm you've met all the requirements by checking all boxes`,
  locationCode: 'Please enter the 6 character location code'
};

export const AddressValidationErrors = {
  streetName: 'Please enter a valid street address.',
  suburb: 'Please enter a valid suburb.',
  place: 'We can’t help you without this information.',
  postcode: 'Please enter a 4-digit postcode.',
  noPostBox: "Sorry, the address can't be a PO Box, GPO Box or Locked Bag.",
  pickAddress:
    "Please choose an address from the list. If your address isn't listed, enter it manually."
};

export const DateValidationErrors = {
  day: 'That doesn’t look right. The day can only be a number between 1 and 31.',
  month: 'That doesn’t look right. The month can only be a number between 1 and 12.',
  year: 'That doesn’t look right. Try entering the year again.',
  invalidDate: 'That date doesn’t exist. Try entering the date again.'
};

export const StorageKeys = {
  State: 'ServiceVictoria.ConstructionRegistration.State'
};

export const Routes = {
  Home: '/',
  Transaction: '/register',
  Others: '*'
};

/**
 * Date constants values
 */
export const Dates = {
  /**
   * Char seperator between the date different sections (day, month, year)
   */
  DATE_DIVIDER_CHAR: '/',

  /**
   * Date format for full mode
   */
  FULL_DATE_FORMAT: 'DD/MM/YYYY',

  /**
   * Date format for partial mode
   */
  MONTH_YEAR_FORMAT: 'MM/YYYY',

  /**
   * Display date format in UX
   */
  DISPLAY_FORMAT: 'DD MMMM YYYY'
};

export const DefaultErrorResponse = {
  title: 'Sorry, there was a problem processing this request.',
  value: 'Please try again.'
};

export const Config = {
  SearchApi: process.env.REACT_APP_CORE_API_DOMAIN || '',
  TransactionStartTs: process.env.REACT_APP_TRANSACTION_START_DATETIME || ''
};
